export default __webpack_public_path__ + "static/media/lissajous2.20797be2.gif";